<div #projectCreateModal class="modal fade modal-project" data-backdrop="static" tabindex='-1'>
  <div class="modal-dialog modal-dialog-centered project-create-modal">
    <div class="modal-content border-radius-0">
      <!-- Modal body -->
      <div class="modal-body p-0">
        <form [formGroup]="registerForm">
          <div class="d-flex project-create-form-content">
            <div class="form-container bg-ultra-light-grey pl-3 pt-3 pb-3 pr-3">
              <img alt="" class="mt-3 pb-2" src="/assets/images/neues_projekt_icon.svg">
              <div class="display-flex mb-4">
                <div class="w-75">
                  @if (isNewProject) {
                    <h4 class="modal-title" i18n="@@app.new_project">New Project</h4>
                  }
                  @if (!isNewProject) {
                    <h4 class="modal-title" i18n="@@app.edit_project">Edit Project</h4>
                  }
                </div>
                @if (userIsOwner) {
                  <div class="display-flex pl-2 cursor-pointer" (click)="toggleShareWithingCompany(shareWithinCompanyCheckmarkElement?.checked)">
                    <div class="text-center display-flex align-items-center ml-2">
                      <label class="switch mb-0 position-relative display-inline-block"  (click)="$event.stopPropagation()">
                        <input #shareWithinCompanyCheckmarkElement
                          id="isProjectSharedWithCompany"
                          formControlName="shareWithinCompany"
                          type="checkbox"
                          [checked]="registerForm.get('shareWithinCompany')">
                          <span class="slider position-absolute"></span>
                        </label>
                      </div>
                      <span class="ml-2 display-flex align-items-center" i18n="@@app.the_project_is_shared_within_the_company">The Project is shared within the company</span>
                    </div>
                  }
                </div>

                <div class="row text-color-brand">
                  <div class="col-md-12 col-lg-12">
                    <label class="font-size-16 text-color-brand font-weight-semibold" i18n="@@app.project_information">Project Information</label>
                  </div>
                </div>
                <!-- Project name -->
                <div class="row mt-3 form-group">
                  <div class="col-md-12 col-lg-12">
                    <label class="text-color-medium-gray"><ng-container i18n="@@app.project_name">Project Name</ng-container><span class="text-color-mandatory">*</span>:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text"
                      formControlName="projectName"
                      class="form-control font-size-s"
                      maxlength="76"
                      #projectName
                      [readOnly]="currentProject?.isShared"
                      required
                         [ngClass]="{'is-invalid': registerForm.get('projectName').invalid &&
                         (registerForm.get('projectName').dirty || registerForm.get('projectName').touched) ||
                         (!registerForm.get('projectName').pristine &&
                         projectNameExists)}"
                      (input)="checkIfProjectNameDuplicate(projectName.value)">
                      @if (registerForm.get('projectName').errors && (registerForm.get('projectName').dirty || registerForm.get('projectName').touched)) {
                        <div
                          class="invalid-feedback">
                          @if (registerForm.get('projectName').errors.required) {
                            <div i18n="@@app.title_is_required">Title is required</div>
                          }
                          @if (registerForm.get('projectName').errors.pattern) {
                            <div i18n="@@app.title_allows_only_alphanumeric">Title allows only Alphanumeric spaces</div>
                          }
                        </div>
                      }
                      @if (!registerForm.get('projectName').pristine && projectNameExists) {
                        <div class="invalid-feedback" i18n="@@app.project_name_already_exists">Project name already exists.</div>
                      }
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="row form-group">
                      <div class="col-md-6 col-lg-6">
                        <span class="text-color-medium-gray"><ng-container i18n="@@app.created">Created</ng-container>:</span>
                        <div>
                          <b>
                            @if (isNewProject) {
                              {{ date | date:'mediumDate':undefined:'de-CH' }}
                              {{ date | date:'shortTime':undefined:'de-CH' }}
                            } @else {
                              {{ currentProject?.created | date:'mediumDate':undefined:'de-CH' }}
                              {{ currentProject?.created | date:'shortTime':undefined:'de-CH' }}
                            }
                          </b>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <span class="text-color-medium-gray"><ng-container i18n="@@app.updated">Updated</ng-container>:</span>
                        <div>
                          <b>
                            @if (isNewProject) {
                              {{ date | date:'mediumDate':undefined:'de-CH' }}
                              {{ date | date:'shortTime':undefined:'de-CH' }}
                            } @else {
                              {{ currentProject?.lastModified | date:'mediumDate':undefined:'de-CH' }}
                              {{ currentProject?.lastModified | date:'shortTime':undefined:'de-CH' }}
                            }
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-2 position-relative">
                    <span class="text-color-medium-gray float-left"><ng-container i18n="@@project_implementation_date">Project implementation date</ng-container>:</span>
                    <div class="tooltip cursor-pointer position-initial mx-1">
                      <span
                      class="cheatSheetIcon se-icon-information_stroke info-icon no-line-height font-size-18 cursor-pointer"></span>
                      <span class="tooltip-text tooltip-right w-50 text-left font-size-xs position-absolute px-2 py-1">
                        <ng-container
                        i18n="@@app.expected_date_of_first_delivery">Expected date of first delivery (e.g. enclosures) does not replace the official order and is used exclusively for forecasts to reduce delivery times.</ng-container>
                      </span>
                    </div>
                    <div>
                      <app-multiple-months-datepicker
                        [dateSelected]="registerForm?.get('installationDate')?.value"
                        [numberOfCalendars]="6"
                        (setNewDate)="changeInstallationDate($event)"
                        (resetInstallationDate)="resetInstallationDate()"
                      ></app-multiple-months-datepicker>
                    </div>
                  </div>
                  <div class="form-group mt-2 position-relative">
                    <label class="text-color-medium-gray" i18n="@@app.description">Description</label>
                    <textarea type="text"
                      placeholder="Project description"
                      i18n-placeholder="@@app.project_description"
                      formControlName="projectDescription"
                      maxlength="100"
                      class="form-control"
                      rows="2"
                      [ngClass]="{ 'is-invalid': registerForm.get('projectDescription').errors }">
                    </textarea>
                    <span class="warn-text-length-position position-absolute font-size-8 font-weight-bold text-color-grey color-icon-red"
                      [hidden]="registerForm?.get('projectDescription')?.value?.length < 80"
                    >{{registerForm?.get('projectDescription')?.value?.length}}/100</span>
                    <div class="help-block with-errors"></div>
                    @if (registerForm.get('projectDescription').errors) {
                      <div class="invalid-feedback">
                        @if (registerForm.get('projectDescription').errors.pattern) {
                          <div>
                            <ng-container i18n="@@app.description_allows_only_alphanumeric_space">Description allows only Alphanumeric Space_,&+*#&#64;!()</ng-container>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group mt-2 position-relative">
                    <label class="text-color-medium-gray" for="formControlTextareaRemarks" i18n="@@app.remarks">Remarks</label>
                    <textarea class="form-control" id="formControlTextareaRemarks"
                      rows="2" i18n-placeholder="@@app.remarks"
                      placeholder="Remarks"
                      [ngClass]="{ 'is-invalid':registerForm?.get('remarks').errors }" formControlName="remarks" maxlength="200">
                    </textarea>
                    <span class="warn-text-length-position position-absolute font-size-8 font-weight-bold text-color-grey color-icon-red"
                      [hidden]="registerForm?.get('remarks')?.value?.length < 180"
                    >{{registerForm?.get('remarks')?.value?.length}}/200</span>
                    @if (registerForm?.get('remarks').errors) {
                      <div class="invalid-feedback">
                        @if (registerForm?.get('remarks').errors.pattern) {
                          <div>
                            <ng-container i18n="@@app.remarks_allows_only_alphanumeric_space">Remarks allows only Alphanumeric Space_,&+*#&#64;!()-=</ng-container>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="form-container pr-3 pt-3 pb-3 pl-3">
                  <div class="row text-color-brand mt-4">
                    <div class="col-md-12 col-lg-12">
                      <label class="font-size-16 text-color-brand font-weight-semibold" i18n="@@app.customer_information">Customer Information</label>
                    </div>
                  </div>
                  <div class="form-group row mt-2">
                    <div class="col-md-12 col-lg-12">
                      <label class="text-color-medium-gray"><ng-container i18n="@@app.customer_name">Customer Name</ng-container>:</label>
                    </div>
                    <div class="col-md-12 col-lg-12">
                      <input formControlName="clientFirstName"
                        (blur)="updateProjectName()"
                        type="text"
                        class="form-control font-size-s"
                        maxlength="25"
                        i18n-placeholder="@@app.customer_name"
                        placeholder="Customer Name"
                        [ngClass]="{ 'is-invalid': registerForm.get('clientFirstName').errors }">
                        @if (registerForm.get('clientFirstName').errors) {
                          <div class="invalid-feedback">
                            @if (registerForm.get('clientFirstName').errors.pattern) {
                              <div>
                                <ng-container i18n="@@app.first_name_allows_only_alphaet_space">First Name allows only Alphabet -space</ng-container>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <!-- contact person -->
                    <div class="form-group row mt-2">
                      <div class="col-md-12 col-lg-12">
                        <label class="text-color-medium-gray"><ng-container i18n="@@app.contact_person">Contact Person</ng-container>:</label>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <input formControlName="contactPerson" type="text"
                          class="form-control font-size-s"
                          maxlength="25"
                          i18n-placeholder="@@app.contact_person" placeholder="Contact Person"
                          [ngClass]="{ 'is-invalid':registerForm?.get('contactPerson')?.errors }">
                        </div>
                      </div>
                      <!-- end of contact person -->
                      <div class="form-group row mt-2">
                        <div class="col-md-12 col-lg-12">
                          <label class="text-color-medium-gray"><ng-container i18n="@@app.street">Street</ng-container>:</label>
                        </div>
                        <div class="col-md-12 col-lg-12">
                          <input type="text"
                            formControlName="street"
                            class="form-control font-size-s"
                            i18n-placeholder="@@app.street"
                            placeholder="Street"
                            maxlength="50"
                            [ngClass]="{ 'is-invalid':registerForm?.get('street').errors }" />
                            @if (registerForm?.get('street').errors) {
                              <div class="invalid-feedback">
                                @if (registerForm?.get('street').errors.pattern) {
                                  <div>
                                    <ng-container i18n="@@app.street_allows_only_alphanumeric">Street allows only Alphanumeric Space_,&+*#&#64;!()-=</ng-container>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="form-group row mt-2">
                          <div class="col-md-12 col-lg-12">
                            <label class="text-color-medium-gray"><ng-container i18n="@@app.postal_code">Postal Code</ng-container>:</label>
                          </div>
                          <div class="col-md-12 col-lg-12">
                            <input type="text"
                              formControlName="clientPostalCode"
                              class="form-control font-size-s"
                              (change)="updateAddressInformation('clientPostalCode')"
                              maxlength="10"
                              i18n-placeholder="@@app.postal_code"
                              placeholder="Postal Code" />
                            </div>
                          </div>
                          <div class="form-group row mt-2">
                            <div class="col-md-12 col-lg-12">
                              <label class="text-color-medium-gray"><ng-container i18n="@@app.city">City</ng-container>:</label>
                            </div>
                            <div class="col-md-12 col-lg-12">
                              <input type="text"
                                formControlName="clientCity"
                                (change)="updateAddressInformation('clientCity')"
                                class="form-control font-size-s"
                                i18n-placeholder="@@app.city"
                                placeholder="City"
                                [ngClass]="{ 'is-invalid':registerForm?.get('clientCity').errors }" maxlength="75" />

                                @if (multipleCities?.length) {
                                  <div class="list-group position-absolute w-200-px z-index-10 border-brand">
                                    @for (city of multipleCities; track city) {
                                      <div class="list-group-item p-1 cursor-pointer list-group-item-action " (click)="choseCity(city)">{{city}}</div>
                                    }
                                  </div>
                                }

                                @if (registerForm?.get('clientCity').errors) {
                                  <div class="invalid-feedback">
                                    @if (registerForm?.get('clientCity').errors.pattern) {
                                      <div>
                                        <ng-container i18n="@@app.city_allows_only_alphabet">City allows only Alphabet -space</ng-container>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="form-group row mt-2">
                              <div class="col-md-12 col-lg-12">
                                <label class="text-color-medium-gray"><ng-container i18n="@@app.email">Email</ng-container>:</label>
                              </div>
                              <div class="col-md-12 col-lg-12">
                                <input type="email"
                                  formControlName="email"
                                  class="form-control font-size-s"
                                  i18n-placeholder="@@app.email"
                                  placeholder="Email"
                                  (keypress)="keyPressBlocker($event)"
                                  [ngClass]="{ 'is-invalid':registerForm?.get('email').errors }"
                                  maxlength="150" />
                                  @if (registerForm?.get('email').errors) {
                                    <div class="invalid-feedback">
                                      @if (registerForm?.get('email').errors.pattern) {
                                        <div>
                                          <ng-container i18n="@@app.enter_the_valid_email">Enter the valid email</ng-container>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="form-group row mt-2">
                                <div class="col-md-12 col-lg-12">
                                  <label class="text-color-medium-gray"><ng-container i18n="@@app.phone">Phone</ng-container>:</label>
                                </div>
                                <div class="col-md-12 col-lg-12">
                                  <input type="text"
                                    formControlName="phoneNumber"
                                    class="form-control font-size-s"
                                    placeholder="Number"
                                    i18n-placeholder="@@app.number"
                                    (focusout)="regeneratePhoneNumber(registerForm.value['phoneNumber'])"
                                    [ngClass]="{ 'is-invalid':registerForm?.get('phoneNumber').errors }"/>
                                    @if (registerForm?.get('phoneNumber').errors) {
                                      <div class="invalid-feedback">
                                        @if (registerForm?.get('phoneNumber').errors.pattern) {
                                          <div>
                                            <ng-container i18n="@@app.enter_the_valid_phone_number">Enter the valid phone number</ng-container>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>

                                <!-- buttons -->
                                <div class="d-flex flex-row mt-4" fxLayoutAlign="end">
                                  <button type="button" class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal" (click)="closeModal()" i18n="@@app.cancel">Cancel</button>
                                  @if (isNewProject) {
                                    <button type="button" class="btn btn-lg btn-primary text-uppercase border-rounded" i18n="@@app.create" (click)="onSubmit(registerForm.value)"
                                    data-dismiss="modal" appDisableMultipleClickWithNoneEvent [disabled]="!registerForm.valid || projectNameExists">Create</button>
                                  }
                                  @if (!isNewProject) {
                                    <button type="button" class="btn btn-primary btn-lg text-uppercase border-rounded font-weight-normal" (click)="onUpdate(registerForm.value)" i18n="@@app.update"
                                    data-dismiss="modal" appDisableMultipleClickWithNoneEvent [disabled]="!registerForm.valid || projectNameExists">Update</button>
                                  }
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
